<template>
  <section class="author__content-desktop">
    <div class="author__logo-and-statistic">
      <author-logo :src="PhotoUrl" :alt-text="fullName" />
      <author-statistic
        :article-count="ArticleCount"
        :follower-count="FollowerCount"
        :is-follow-author-button-visible="isFollowAuthorButtonVisible"
        :is-followed="IsFollowed"
        :author-id="Id"
      />
    </div>
    <div class="author__info">
      <div class="author__content-top-section">
        <author-name-and-position
          :name="fullName"
          :job-title="Job"
          :company="Company"
        />

        <a-visibility show :from="$breakpoint.desktopXl">
          <div class="author__become-an-author__wrapper">
            <become-an-author-button />
            <author-icons
              :facebook-url="FacebookUrl"
              :twitter-url="TwitterUrl"
              :linked-in-url="LinkedInUrl"
              :telegram-url="TelegramUrl"
            />
          </div>
        </a-visibility>
      </div>

      <author-about :about="Bio" />

      <a-visibility show :to="$breakpoint.desktopLg">
        <div class="author__become-an-author__wrapper">
          <author-icons
            :facebook-url="FacebookUrl"
            :twitter-url="TwitterUrl"
            :linked-in-url="LinkedInUrl"
            :telegram-url="TelegramUrl"
          />
          <become-an-author-button />
        </div>
      </a-visibility>
    </div>
  </section>
</template>

<script>
import mixins from '@/utils/mixins'
import AuthorLogo from '@/components/_sections/author/AuthorDetails/AuthorLogo/index.vue'
import AuthorNameAndPosition from '@/components/_sections/author/AuthorDetails/AuthorNameAndPosition/index.vue'
import AuthorAbout from '@/components/_sections/author/AuthorDetails/AuthorAbout/index.vue'
import AuthorStatistic from '@/components/_sections/author/AuthorDetails/AuthorStatistic/index.vue'
import BecomeAnAuthorButton from '@/components/_sections/author/AuthorDetails/BecomeAnAuthorButton/index.vue'
import AuthorIcons from '@/components/_sections/author/AuthorDetails/AuthorIcons/index.vue'

export default {
  name: 'AuthorDetailsDesktop',
  mixins: [mixins.authorDetails],
  components: {
    AuthorLogo,
    AuthorNameAndPosition,
    AuthorAbout,
    AuthorStatistic,
    BecomeAnAuthorButton,
    AuthorIcons
  }
}
</script>

<style lang="scss" scoped></style>
